import React, { useRef } from 'react';
import CodeHighlight from './../../components/code-highlight/code-highlight.jsx';
import useTemplateInteractions from './../../composables/templateInteractions.js';

function UIIconIonicons() {
	const rootRef = useRef(null);
	useTemplateInteractions(rootRef);

	return (
		<div ref={rootRef}>
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-xl-10">
						<div className="row">
							<div className="col-xl-9">
								<ul className="breadcrumb">
									<li className="breadcrumb-item">
										<a href="#/">{'UI Elements'}</a>
									</li>
									<li className="breadcrumb-item active"></li>
								</ul>
								<h1 className="page-header">
									{' Ionicons '}
									<small>
										{'v7.x bundle with 1,000+ icons (outline / filled / sharp style icons)'}
									</small>
								</h1>
								<hr className="mb-4" />
								<div id="usage" className="mb-5">
									<h4>{'Usage'}</h4>
									<p>
										{
											' Use Ionicons to add crisp, modern icons designed for web, iOS, and Android apps. Their lightweight SVG format makes them perfect for responsive, high-resolution interfaces. Please read the official '
										}
										<a href="https://ionic.io/ionicons" target="_blank" rel="noreferrer">
											{'Ionicons'}
										</a>
										{' documentation for the full list of icons. '}
									</p>
									<div className="card">
										<div className="p-2 border-bottom">
											<ul id="ioniconsTab" className="nav nav-pills">
												<li className="nav-item">
													<a
														href="#outline"
														data-bs-toggle="tab"
														className="nav-link active d-flex align-items-center"
													>
														<ion-icon
															name="aperture-outline"
															className="fs-18px"
														></ion-icon>
														<span className="d-none d-lg-inline ms-2">
															{'Outline (414)'}
														</span>
														{' '}
													</a>
												</li>
												<li className="nav-item ms-2">
													<a
														href="#filled"
														data-bs-toggle="tab"
														className="nav-link d-flex align-items-center"
													>
														<ion-icon name="aperture" className="fs-18px"></ion-icon>
														<span className="d-none d-lg-inline ms-2">
															{'Filled (414)'}
														</span>
														{' '}
													</a>
												</li>
												<li className="nav-item ms-2">
													<a
														href="#sharp"
														data-bs-toggle="tab"
														className="nav-link d-flex align-items-center"
													>
														<ion-icon name="aperture-sharp" className="fs-18px"></ion-icon>
														<span className="d-none d-lg-inline ms-2">{'Sharp (414)'}</span>
														{' '}
													</a>
												</li>
												<li className="nav-item ms-2">
													<a
														href="#logo"
														data-bs-toggle="tab"
														className="nav-link d-flex align-items-center"
													>
														<ion-icon name="logo-apple" className="fs-18px"></ion-icon>
														<span className="d-none d-lg-inline ms-2">{'Logo (90)'}</span>
														{' '}
													</a>
												</li>
											</ul>
										</div>
										<div data-scrollbar="true" data-height="50vh">
											<div className="card-body">
												<div id="ioniconsTabContent" className="tab-content small fw-semibold">
													<div className="tab-pane fade show active" id="outline">
														<div className="row">
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="accessibility-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'accessibility-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="add-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'add-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="add-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'add-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="airplane-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'airplane-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="alarm-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'alarm-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="albums-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'albums-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="alert-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'alert-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="alert-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'alert-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="american-football-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'american-football-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="analytics-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'analytics-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="aperture-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'aperture-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="apps-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'apps-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="archive-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'archive-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-back-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-back-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-back-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-back-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-down-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-down-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-down-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-down-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-forward-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-forward-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-forward-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-forward-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-redo-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-redo-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-redo-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-redo-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-undo-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-undo-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-undo-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-undo-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-up-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-up-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-up-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-up-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="at-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'at-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="at-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'at-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="attach-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'attach-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="backspace-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'backspace-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bag-add-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bag-add-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bag-check-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'bag-check-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bag-handle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'bag-handle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bag-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bag-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bag-remove-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'bag-remove-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="balloon-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'balloon-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ban-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'ban-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bandage-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bandage-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bar-chart-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'bar-chart-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="barbell-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'barbell-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="barcode-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'barcode-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="baseball-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'baseball-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="basket-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'basket-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="basketball-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'basketball-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="battery-charging-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'battery-charging-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="battery-dead-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'battery-dead-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="battery-full-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'battery-full-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="battery-half-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'battery-half-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="beaker-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'beaker-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bed-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bed-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="beer-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'beer-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bicycle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bicycle-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bluetooth-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'bluetooth-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="boat-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'boat-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="body-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'body-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bonfire-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bonfire-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="book-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'book-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bookmark-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'bookmark-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bookmarks-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'bookmarks-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bowling-ball-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'bowling-ball-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="briefcase-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'briefcase-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="browsers-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'browsers-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="brush-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'brush-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bug-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bug-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="build-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'build-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bulb-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bulb-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bus-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bus-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="business-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'business-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cafe-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cafe-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="calculator-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'calculator-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="calendar-clear-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'calendar-clear-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="calendar-number-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'calendar-number-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="calendar-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'calendar-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="call-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'call-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="camera-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'camera-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="camera-reverse-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'camera-reverse-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="car-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'car-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="car-sport-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'car-sport-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="card-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'card-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="caret-back-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'caret-back-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="caret-back-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'caret-back-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="caret-down-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'caret-down-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="caret-down-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'caret-down-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="caret-forward-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'caret-forward-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="caret-forward-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'caret-forward-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="caret-up-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'caret-up-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="caret-up-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'caret-up-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cart-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cart-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cash-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cash-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cellular-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'cellular-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chatbox-ellipses-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chatbox-ellipses-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chatbox-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'chatbox-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chatbubble-ellipses-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chatbubble-ellipses-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chatbubble-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chatbubble-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chatbubbles-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chatbubbles-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="checkbox-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'checkbox-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="checkmark-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'checkmark-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="checkmark-done-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'checkmark-done-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="checkmark-done-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'checkmark-done-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="checkmark-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'checkmark-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chevron-back-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chevron-back-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chevron-back-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chevron-back-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chevron-down-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chevron-down-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chevron-down-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chevron-down-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chevron-forward-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chevron-forward-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chevron-forward-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chevron-forward-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chevron-up-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chevron-up-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chevron-up-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chevron-up-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="clipboard-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'clipboard-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="close-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'close-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="close-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'close-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cloud-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'cloud-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cloud-done-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'cloud-done-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cloud-download-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'cloud-download-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cloud-offline-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'cloud-offline-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cloud-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cloud-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cloud-upload-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'cloud-upload-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cloudy-night-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'cloudy-night-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cloudy-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cloudy-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="code-download-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'code-download-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="code-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'code-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="code-slash-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'code-slash-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="code-working-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'code-working-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cog-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cog-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="color-fill-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'color-fill-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="color-filter-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'color-filter-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="color-palette-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'color-palette-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="color-wand-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'color-wand-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="compass-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'compass-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="construct-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'construct-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="contract-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'contract-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="contrast-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'contrast-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="copy-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'copy-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="create-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'create-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="crop-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'crop-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cube-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cube-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cut-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cut-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="desktop-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'desktop-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="diamond-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'diamond-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="dice-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'dice-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="disc-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'disc-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="document-attach-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'document-attach-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="document-lock-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'document-lock-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="document-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'document-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="document-text-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'document-text-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="documents-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'documents-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="download-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'download-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="duplicate-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'duplicate-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ear-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'ear-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="earth-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'earth-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="easel-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'easel-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="egg-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'egg-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ellipse-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'ellipse-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ellipsis-horizontal-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'ellipsis-horizontal-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ellipsis-horizontal-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'ellipsis-horizontal-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ellipsis-vertical-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'ellipsis-vertical-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ellipsis-vertical-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'ellipsis-vertical-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="enter-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'enter-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="exit-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'exit-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="expand-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'expand-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="extension-puzzle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'extension-puzzle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="eye-off-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'eye-off-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="eye-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'eye-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="eyedrop-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'eyedrop-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="fast-food-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'fast-food-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="female-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'female-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="file-tray-full-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'file-tray-full-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="file-tray-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'file-tray-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="file-tray-stacked-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'file-tray-stacked-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="film-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'film-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="filter-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'filter-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="filter-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'filter-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="finger-print-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'finger-print-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="fish-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'fish-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="fitness-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'fitness-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="flag-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'flag-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="flame-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'flame-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="flash-off-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'flash-off-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="flash-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'flash-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="flashlight-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'flashlight-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="flask-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'flask-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="flower-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'flower-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="folder-open-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'folder-open-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="folder-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'folder-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="football-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'football-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="footsteps-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'footsteps-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="funnel-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'funnel-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="game-controller-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'game-controller-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="gift-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'gift-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="git-branch-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'git-branch-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="git-commit-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'git-commit-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="git-compare-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'git-compare-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="git-merge-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'git-merge-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="git-network-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'git-network-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="git-pull-request-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'git-pull-request-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="glasses-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'glasses-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="globe-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'globe-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="golf-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'golf-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="grid-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'grid-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="hammer-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'hammer-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="hand-left-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'hand-left-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="hand-right-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'hand-right-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="happy-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'happy-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="hardware-chip-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'hardware-chip-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="headset-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'headset-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="heart-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'heart-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="heart-dislike-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'heart-dislike-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="heart-dislike-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'heart-dislike-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="heart-half-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'heart-half-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="heart-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'heart-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="help-buoy-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'help-buoy-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="help-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'help-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="help-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'help-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="home-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'home-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="hourglass-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'hourglass-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ice-cream-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'ice-cream-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="id-card-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'id-card-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="image-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'image-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="images-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'images-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="infinite-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'infinite-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="information-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'information-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="information-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'information-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="invert-mode-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'invert-mode-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="journal-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'journal-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="key-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'key-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="keypad-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'keypad-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="language-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'language-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="laptop-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'laptop-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="layers-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'layers-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="leaf-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'leaf-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="library-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'library-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="link-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'link-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="list-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'list-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="list-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'list-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="locate-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'locate-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="location-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'location-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="lock-closed-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'lock-closed-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="lock-open-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'lock-open-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="log-in-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'log-in-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="log-out-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'log-out-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="magnet-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'magnet-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="mail-open-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'mail-open-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="mail-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'mail-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="mail-unread-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'mail-unread-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="male-female-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'male-female-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="male-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'male-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="man-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'man-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="map-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'map-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="medal-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'medal-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="medical-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'medical-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="medkit-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'medkit-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="megaphone-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'megaphone-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="menu-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'menu-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="mic-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'mic-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="mic-off-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'mic-off-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="mic-off-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'mic-off-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="mic-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'mic-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="moon-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'moon-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="move-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'move-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="musical-note-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'musical-note-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="musical-notes-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'musical-notes-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="navigate-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'navigate-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="navigate-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'navigate-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="newspaper-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'newspaper-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="notifications-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'notifications-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="notifications-off-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'notifications-off-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="notifications-off-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'notifications-off-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="notifications-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'notifications-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="nuclear-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'nuclear-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="nutrition-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'nutrition-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="open-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'open-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="options-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'options-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="paper-plane-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'paper-plane-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="partly-sunny-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'partly-sunny-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pause-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'pause-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pause-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pause-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="paw-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'paw-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pencil-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pencil-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="people-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'people-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="people-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'people-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="person-add-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'person-add-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="person-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'person-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="person-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'person-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="person-remove-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'person-remove-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="phone-landscape-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'phone-landscape-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="phone-portrait-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'phone-portrait-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pie-chart-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'pie-chart-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pin-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pin-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pint-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pint-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pizza-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pizza-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="planet-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'planet-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-back-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'play-back-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-back-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'play-back-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'play-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-forward-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'play-forward-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-forward-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'play-forward-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'play-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-skip-back-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'play-skip-back-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-skip-back-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'play-skip-back-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-skip-forward-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'play-skip-forward-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-skip-forward-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'play-skip-forward-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="podium-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'podium-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="power-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'power-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pricetag-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'pricetag-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pricetags-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'pricetags-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="print-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'print-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="prism-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'prism-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pulse-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pulse-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="push-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'push-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="qr-code-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'qr-code-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="radio-button-off-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'radio-button-off-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="radio-button-on-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'radio-button-on-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="radio-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'radio-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="rainy-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'rainy-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="reader-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'reader-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="receipt-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'receipt-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="recording-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'recording-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="refresh-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'refresh-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="refresh-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'refresh-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="reload-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'reload-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="reload-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'reload-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="remove-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'remove-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="remove-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'remove-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="reorder-four-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'reorder-four-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="reorder-three-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'reorder-three-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="reorder-two-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'reorder-two-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="repeat-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'repeat-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="resize-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'resize-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="restaurant-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'restaurant-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="return-down-back-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'return-down-back-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="return-down-forward-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'return-down-forward-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="return-up-back-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'return-up-back-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="return-up-forward-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'return-up-forward-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ribbon-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'ribbon-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="rocket-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'rocket-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="rose-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'rose-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="sad-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'sad-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="save-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'save-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="scale-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'scale-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="scan-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'scan-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="scan-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'scan-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="school-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'school-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="search-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'search-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="search-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'search-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="send-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'send-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="server-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'server-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="settings-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'settings-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="shapes-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'shapes-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="share-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'share-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="share-social-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'share-social-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="shield-checkmark-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'shield-checkmark-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="shield-half-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'shield-half-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="shield-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'shield-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="shirt-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'shirt-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="shuffle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'shuffle-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="skull-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'skull-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="snow-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'snow-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="sparkles-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'sparkles-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="speedometer-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'speedometer-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="square-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'square-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="star-half-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'star-half-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="star-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'star-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="stats-chart-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'stats-chart-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="stop-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'stop-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="stop-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'stop-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="stopwatch-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'stopwatch-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="storefront-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'storefront-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="subway-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'subway-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="sunny-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'sunny-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="swap-horizontal-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'swap-horizontal-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="swap-vertical-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'swap-vertical-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="sync-circle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'sync-circle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="sync-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'sync-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="tablet-landscape-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'tablet-landscape-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="tablet-portrait-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'tablet-portrait-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="telescope-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'telescope-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="tennisball-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'tennisball-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="terminal-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'terminal-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="text-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'text-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="thermometer-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'thermometer-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="thumbs-down-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'thumbs-down-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="thumbs-up-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'thumbs-up-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="thunderstorm-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'thunderstorm-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ticket-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'ticket-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="time-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'time-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="timer-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'timer-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="today-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'today-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="toggle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'toggle-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="trail-sign-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'trail-sign-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="train-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'train-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="transgender-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'transgender-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="trash-bin-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'trash-bin-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="trash-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'trash-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="trending-down-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'trending-down-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="trending-up-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'trending-up-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="triangle-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'triangle-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="trophy-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'trophy-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="tv-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'tv-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="umbrella-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'umbrella-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="unlink-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'unlink-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="videocam-off-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'videocam-off-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="videocam-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'videocam-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="volume-high-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'volume-high-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="volume-low-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'volume-low-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="volume-medium-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'volume-medium-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="volume-mute-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'volume-mute-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="volume-off-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'volume-off-outline'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="walk-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'walk-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="wallet-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'wallet-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="warning-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'warning-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="watch-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'watch-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="water-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'water-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="wifi-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'wifi-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="wine-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'wine-outline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="woman-outline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'woman-outline'}</div>
															</div>
														</div>
													</div>
													<div className="tab-pane fade" id="filled">
														<div className="row">
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="accessibility"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'accessibility'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="add-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'add-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="add"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'add'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="airplane"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'airplane'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="alarm"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'alarm'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="albums"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'albums'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="alert-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'alert-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="alert"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'alert'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="american-football"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'american-football'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="analytics"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'analytics'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="aperture"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'aperture'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="apps"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'apps'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="archive"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'archive'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-back-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-back-circle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-back"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'arrow-back'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-down-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-down-circle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-down"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'arrow-down'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-forward-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-forward-circle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-forward"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'arrow-forward'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-redo-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-redo-circle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-redo"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'arrow-redo'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-undo-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-undo-circle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-undo"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'arrow-undo'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-up-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'arrow-up-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-up"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'arrow-up'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="at-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'at-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="at"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'at'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="attach"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'attach'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="backspace"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'backspace'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bag-add"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bag-add'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bag-check"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bag-check'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bag-handle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bag-handle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bag-remove"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bag-remove'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bag"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bag'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="balloon"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'balloon'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ban"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'ban'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bandage"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bandage'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bar-chart"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bar-chart'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="barbell"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'barbell'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="barcode"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'barcode'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="baseball"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'baseball'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="basket"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'basket'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="basketball"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'basketball'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="battery-charging"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'battery-charging'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="battery-dead"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'battery-dead'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="battery-full"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'battery-full'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="battery-half"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'battery-half'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="beaker"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'beaker'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bed"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bed'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="beer"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'beer'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bicycle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bicycle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bluetooth"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bluetooth'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="boat"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'boat'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="body"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'body'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bonfire"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bonfire'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="book"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'book'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bookmark"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bookmark'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bookmarks"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bookmarks'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bowling-ball"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bowling-ball'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="briefcase"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'briefcase'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="browsers"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'browsers'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="brush"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'brush'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bug"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bug'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="build"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'build'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bulb"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bulb'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bus"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bus'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="business"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'business'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cafe"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cafe'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="calculator"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'calculator'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="calendar-clear"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'calendar-clear'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="calendar-number"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'calendar-number'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="calendar"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'calendar'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="call"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'call'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="camera-reverse"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'camera-reverse'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="camera"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'camera'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="car-sport"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'car-sport'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="car"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'car'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="card"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'card'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="caret-back-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'caret-back-circle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="caret-back"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'caret-back'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="caret-down-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'caret-down-circle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="caret-down"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'caret-down'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="caret-forward-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'caret-forward-circle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="caret-forward"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'caret-forward'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="caret-up-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'caret-up-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="caret-up"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'caret-up'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cart"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cart'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cash"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cash'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cellular"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cellular'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chatbox-ellipses"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chatbox-ellipses'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chatbox"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'chatbox'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chatbubble-ellipses"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chatbubble-ellipses'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chatbubble"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'chatbubble'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chatbubbles"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'chatbubbles'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="checkbox"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'checkbox'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="checkmark-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'checkmark-circle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="checkmark-done-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'checkmark-done-circle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="checkmark-done"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'checkmark-done'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="checkmark"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'checkmark'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chevron-back-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chevron-back-circle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chevron-back"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'chevron-back'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chevron-down-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chevron-down-circle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chevron-down"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'chevron-down'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chevron-forward-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chevron-forward-circle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chevron-forward"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'chevron-forward'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chevron-up-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chevron-up-circle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chevron-up"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'chevron-up'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="clipboard"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'clipboard'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="close-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'close-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="close"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'close'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cloud-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cloud-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cloud-done"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cloud-done'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cloud-download"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cloud-download'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cloud-offline"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cloud-offline'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cloud-upload"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cloud-upload'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cloud"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cloud'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cloudy-night"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cloudy-night'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cloudy"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cloudy'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="code-download"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'code-download'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="code-slash"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'code-slash'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="code-working"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'code-working'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="code"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'code'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cog"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cog'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="color-fill"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'color-fill'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="color-filter"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'color-filter'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="color-palette"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'color-palette'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="color-wand"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'color-wand'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="compass"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'compass'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="construct"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'construct'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="contract"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'contract'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="contrast"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'contrast'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="copy"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'copy'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="create"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'create'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="crop"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'crop'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cube"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cube'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cut"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cut'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="desktop"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'desktop'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="diamond"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'diamond'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="dice"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'dice'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="disc"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'disc'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="document-attach"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'document-attach'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="document-lock"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'document-lock'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="document-text"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'document-text'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="document"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'document'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="documents"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'documents'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="download"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'download'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="duplicate"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'duplicate'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ear"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'ear'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="earth"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'earth'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="easel"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'easel'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="egg"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'egg'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ellipse"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'ellipse'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ellipsis-horizontal-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'ellipsis-horizontal-circle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ellipsis-horizontal"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'ellipsis-horizontal'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ellipsis-vertical-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'ellipsis-vertical-circle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ellipsis-vertical"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'ellipsis-vertical'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="enter"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'enter'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="exit"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'exit'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="expand"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'expand'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="extension-puzzle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'extension-puzzle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="eye-off"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'eye-off'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="eye"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'eye'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="eyedrop"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'eyedrop'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="fast-food"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'fast-food'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="female"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'female'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="file-tray-full"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'file-tray-full'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="file-tray-stacked"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'file-tray-stacked'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="file-tray"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'file-tray'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="film"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'film'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="filter-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'filter-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="filter"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'filter'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="finger-print"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'finger-print'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="fish"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'fish'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="fitness"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'fitness'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="flag"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'flag'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="flame"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'flame'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="flash-off"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'flash-off'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="flash"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'flash'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="flashlight"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'flashlight'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="flask"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'flask'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="flower"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'flower'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="folder-open"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'folder-open'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="folder"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'folder'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="football"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'football'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="footsteps"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'footsteps'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="funnel"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'funnel'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="game-controller"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'game-controller'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="gift"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'gift'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="git-branch"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'git-branch'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="git-commit"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'git-commit'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="git-compare"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'git-compare'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="git-merge"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'git-merge'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="git-network"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'git-network'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="git-pull-request"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'git-pull-request'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="glasses"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'glasses'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="globe"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'globe'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="golf"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'golf'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="grid"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'grid'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="hammer"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'hammer'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="hand-left"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'hand-left'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="hand-right"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'hand-right'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="happy"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'happy'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="hardware-chip"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'hardware-chip'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="headset"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'headset'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="heart-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'heart-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="heart-dislike-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'heart-dislike-circle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="heart-dislike"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'heart-dislike'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="heart-half"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'heart-half'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="heart"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'heart'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="help-buoy"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'help-buoy'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="help-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'help-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="help"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'help'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="home"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'home'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="hourglass"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'hourglass'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ice-cream"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'ice-cream'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="id-card"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'id-card'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="image"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'image'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="images"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'images'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="infinite"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'infinite'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="information-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'information-circle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="information"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'information'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="invert-mode"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'invert-mode'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="journal"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'journal'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="key"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'key'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="keypad"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'keypad'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="language"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'language'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="laptop"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'laptop'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="layers"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'layers'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="leaf"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'leaf'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="library"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'library'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="link"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'link'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="list-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'list-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="list"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'list'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="locate"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'locate'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="location"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'location'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="lock-closed"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'lock-closed'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="lock-open"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'lock-open'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="log-in"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'log-in'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="log-out"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'log-out'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-alipay"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-alipay'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-amazon"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-amazon'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-amplify"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-amplify'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-android"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-android'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-angular"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-angular'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-apple-appstore"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'logo-apple-appstore'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-apple-ar"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-apple-ar'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-apple"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-apple'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-behance"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-behance'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-bitbucket"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-bitbucket'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-bitcoin"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-bitcoin'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-buffer"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-buffer'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-capacitor"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-capacitor'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-chrome"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-chrome'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-closed-captioning"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'logo-closed-captioning'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-codepen"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-codepen'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-css3"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-css3'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-designernews"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'logo-designernews'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-deviantart"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-deviantart'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-discord"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-discord'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-docker"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-docker'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-dribbble"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-dribbble'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-dropbox"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-dropbox'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-edge"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-edge'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-electron"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-electron'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-euro"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-euro'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-facebook"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-facebook'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-figma"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-figma'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-firebase"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-firebase'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-firefox"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-firefox'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-flickr"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-flickr'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-foursquare"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-foursquare'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-github"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-github'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-gitlab"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-gitlab'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-google-playstore"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'logo-google-playstore'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-google"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-google'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-hackernews"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-hackernews'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-html5"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-html5'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-instagram"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-instagram'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-ionic"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-ionic'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-ionitron"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-ionitron'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-javascript"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-javascript'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-laravel"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-laravel'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-linkedin"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-linkedin'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-markdown"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-markdown'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-mastodon"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-mastodon'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-medium"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-medium'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-microsoft"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-microsoft'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-no-smoking"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-no-smoking'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-nodejs"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-nodejs'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-npm"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-npm'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-octocat"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-octocat'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-paypal"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-paypal'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-pinterest"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-pinterest'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-playstation"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'logo-playstation'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-pwa"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-pwa'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-python"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-python'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-react"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-react'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-reddit"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-reddit'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-rss"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-rss'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-sass"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-sass'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-skype"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-skype'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-slack"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-slack'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-snapchat"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-snapchat'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-soundcloud"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-soundcloud'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-stackoverflow"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'logo-stackoverflow'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-steam"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-steam'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-stencil"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-stencil'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-tableau"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-tableau'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-tiktok"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-tiktok'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-tumblr"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-tumblr'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-tux"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-tux'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-twitch"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-twitch'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-twitter"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-twitter'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-usd"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-usd'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-venmo"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-venmo'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-vercel"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-vercel'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-vimeo"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-vimeo'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-vk"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-vk'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-vue"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-vue'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-web-component"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'logo-web-component'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-wechat"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-wechat'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-whatsapp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-whatsapp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-windows"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-windows'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-wordpress"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-wordpress'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-xbox"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-xbox'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-xing"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-xing'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-yahoo"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-yahoo'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-yen"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-yen'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-youtube"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-youtube'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="magnet"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'magnet'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="mail-open"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'mail-open'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="mail-unread"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'mail-unread'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="mail"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'mail'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="male-female"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'male-female'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="male"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'male'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="man"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'man'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="map"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'map'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="medal"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'medal'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="medical"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'medical'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="medkit"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'medkit'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="megaphone"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'megaphone'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="menu"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'menu'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="mic-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'mic-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="mic-off-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'mic-off-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="mic-off"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'mic-off'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="mic"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'mic'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="moon"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'moon'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="move"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'move'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="musical-note"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'musical-note'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="musical-notes"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'musical-notes'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="navigate-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'navigate-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="navigate"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'navigate'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="newspaper"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'newspaper'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="notifications-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'notifications-circle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="notifications-off-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'notifications-off-circle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="notifications-off"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'notifications-off'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="notifications"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'notifications'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="nuclear"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'nuclear'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="nutrition"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'nutrition'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="open"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'open'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="options"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'options'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="paper-plane"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'paper-plane'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="partly-sunny"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'partly-sunny'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pause-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pause-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pause"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pause'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="paw"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'paw'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pencil"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pencil'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="people-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'people-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="people"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'people'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="person-add"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'person-add'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="person-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'person-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="person-remove"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'person-remove'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="person"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'person'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="phone-landscape"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'phone-landscape'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="phone-portrait"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'phone-portrait'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pie-chart"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pie-chart'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pin"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pin'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pint"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pint'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pizza"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pizza'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="planet"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'planet'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-back-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'play-back-circle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-back"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'play-back'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'play-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-forward-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'play-forward-circle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-forward"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'play-forward'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-skip-back-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'play-skip-back-circle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-skip-back"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'play-skip-back'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-skip-forward-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'play-skip-forward-circle'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-skip-forward"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'play-skip-forward'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'play'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="podium"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'podium'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="power"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'power'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pricetag"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pricetag'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pricetags"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pricetags'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="print"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'print'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="prism"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'prism'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pulse"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pulse'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="push"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'push'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="qr-code"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'qr-code'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="radio-button-off"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'radio-button-off'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="radio-button-on"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'radio-button-on'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="radio"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'radio'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="rainy"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'rainy'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="reader"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'reader'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="receipt"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'receipt'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="recording"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'recording'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="refresh-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'refresh-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="refresh"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'refresh'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="reload-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'reload-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="reload"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'reload'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="remove-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'remove-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="remove"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'remove'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="reorder-four"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'reorder-four'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="reorder-three"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'reorder-three'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="reorder-two"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'reorder-two'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="repeat"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'repeat'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="resize"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'resize'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="restaurant"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'restaurant'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="return-down-back"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'return-down-back'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="return-down-forward"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'return-down-forward'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="return-up-back"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'return-up-back'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="return-up-forward"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'return-up-forward'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ribbon"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'ribbon'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="rocket"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'rocket'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="rose"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'rose'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="sad"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'sad'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="save"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'save'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="scale"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'scale'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="scan-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'scan-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="scan"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'scan'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="school"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'school'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="search-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'search-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="search"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'search'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="send"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'send'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="server"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'server'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="settings"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'settings'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="shapes"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'shapes'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="share-social"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'share-social'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="share"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'share'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="shield-checkmark"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'shield-checkmark'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="shield-half"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'shield-half'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="shield"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'shield'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="shirt"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'shirt'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="shuffle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'shuffle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="skull"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'skull'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="snow"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'snow'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="sparkles"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'sparkles'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="speedometer"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'speedometer'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="square"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'square'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="star-half"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'star-half'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="star"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'star'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="stats-chart"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'stats-chart'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="stop-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'stop-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="stop"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'stop'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="stopwatch"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'stopwatch'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="storefront"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'storefront'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="subway"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'subway'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="sunny"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'sunny'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="swap-horizontal"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'swap-horizontal'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="swap-vertical"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'swap-vertical'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="sync-circle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'sync-circle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="sync"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'sync'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="tablet-landscape"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'tablet-landscape'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="tablet-portrait"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'tablet-portrait'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="telescope"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'telescope'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="tennisball"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'tennisball'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="terminal"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'terminal'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="text"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'text'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="thermometer"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'thermometer'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="thumbs-down"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'thumbs-down'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="thumbs-up"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'thumbs-up'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="thunderstorm"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'thunderstorm'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ticket"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'ticket'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="time"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'time'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="timer"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'timer'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="today"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'today'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="toggle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'toggle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="trail-sign"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'trail-sign'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="train"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'train'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="transgender"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'transgender'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="trash-bin"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'trash-bin'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="trash"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'trash'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="trending-down"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'trending-down'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="trending-up"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'trending-up'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="triangle"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'triangle'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="trophy"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'trophy'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="tv"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'tv'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="umbrella"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'umbrella'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="unlink"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'unlink'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="videocam-off"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'videocam-off'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="videocam"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'videocam'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="volume-high"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'volume-high'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="volume-low"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'volume-low'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="volume-medium"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'volume-medium'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="volume-mute"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'volume-mute'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="volume-off"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'volume-off'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="walk"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'walk'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="wallet"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'wallet'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="warning"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'warning'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="watch"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'watch'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="water"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'water'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="wifi"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'wifi'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="wine"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'wine'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="woman"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'woman'}</div>
															</div>
														</div>
													</div>
													<div className="tab-pane fade" id="sharp">
														<div className="row">
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="accessibility-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'accessibility-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="add-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'add-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="add-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'add-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="airplane-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'airplane-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="alarm-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'alarm-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="albums-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'albums-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="alert-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'alert-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="alert-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'alert-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="american-football-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'american-football-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="analytics-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'analytics-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="aperture-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'aperture-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="apps-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'apps-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="archive-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'archive-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-back-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-back-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-back-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-back-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-down-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-down-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-down-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-down-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-forward-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-forward-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-forward-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-forward-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-redo-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-redo-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-redo-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-redo-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-undo-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-undo-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-undo-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-undo-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-up-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'arrow-up-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="arrow-up-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'arrow-up-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="at-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'at-circle-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="at-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'at-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="attach-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'attach-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="backspace-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'backspace-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bag-add-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bag-add-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bag-check-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bag-check-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bag-handle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'bag-handle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bag-remove-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'bag-remove-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bag-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bag-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="balloon-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'balloon-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ban-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'ban-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bandage-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bandage-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bar-chart-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bar-chart-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="barbell-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'barbell-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="barcode-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'barcode-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="baseball-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'baseball-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="basket-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'basket-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="basketball-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'basketball-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="battery-charging-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'battery-charging-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="battery-dead-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'battery-dead-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="battery-full-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'battery-full-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="battery-half-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'battery-half-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="beaker-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'beaker-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bed-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bed-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="beer-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'beer-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bicycle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bicycle-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bluetooth-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bluetooth-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="boat-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'boat-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="body-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'body-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bonfire-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bonfire-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="book-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'book-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bookmark-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bookmark-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bookmarks-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bookmarks-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bowling-ball-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'bowling-ball-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="briefcase-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'briefcase-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="browsers-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'browsers-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="brush-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'brush-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bug-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bug-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="build-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'build-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bulb-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bulb-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="bus-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'bus-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="business-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'business-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cafe-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cafe-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="calculator-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'calculator-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="calendar-clear-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'calendar-clear-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="calendar-number-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'calendar-number-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="calendar-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'calendar-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="call-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'call-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="camera-reverse-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'camera-reverse-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="camera-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'camera-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="car-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'car-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="car-sport-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'car-sport-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="card-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'card-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="caret-back-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'caret-back-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="caret-back-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'caret-back-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="caret-down-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'caret-down-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="caret-down-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'caret-down-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="caret-forward-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'caret-forward-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="caret-forward-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'caret-forward-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="caret-up-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'caret-up-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="caret-up-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'caret-up-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cart-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cart-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cash-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cash-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cellular-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cellular-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chatbox-ellipses-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chatbox-ellipses-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chatbox-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'chatbox-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chatbubble-ellipses-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chatbubble-ellipses-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chatbubble-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chatbubble-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chatbubbles-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chatbubbles-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="checkbox-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'checkbox-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="checkmark-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'checkmark-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="checkmark-done-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'checkmark-done-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="checkmark-done-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'checkmark-done-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="checkmark-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'checkmark-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chevron-back-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chevron-back-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chevron-back-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chevron-back-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chevron-down-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chevron-down-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chevron-down-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chevron-down-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chevron-forward-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chevron-forward-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chevron-forward-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chevron-forward-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chevron-up-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chevron-up-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="chevron-up-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'chevron-up-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="clipboard-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'clipboard-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="close-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'close-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="close-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'close-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cloud-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'cloud-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cloud-done-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'cloud-done-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cloud-download-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'cloud-download-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cloud-offline-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'cloud-offline-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cloud-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cloud-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cloud-upload-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'cloud-upload-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cloudy-night-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'cloudy-night-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cloudy-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cloudy-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="code-download-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'code-download-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="code-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'code-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="code-slash-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'code-slash-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="code-working-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'code-working-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cog-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cog-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="color-fill-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'color-fill-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="color-filter-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'color-filter-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="color-palette-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'color-palette-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="color-wand-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'color-wand-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="compass-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'compass-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="construct-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'construct-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="contract-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'contract-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="contrast-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'contrast-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="copy-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'copy-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="create-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'create-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="crop-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'crop-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cube-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cube-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="cut-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'cut-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="desktop-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'desktop-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="diamond-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'diamond-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="dice-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'dice-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="disc-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'disc-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="document-attach-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'document-attach-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="document-lock-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'document-lock-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="document-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'document-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="document-text-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'document-text-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="documents-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'documents-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="download-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'download-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="duplicate-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'duplicate-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ear-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'ear-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="earth-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'earth-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="easel-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'easel-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="egg-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'egg-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ellipse-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'ellipse-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ellipsis-horizontal-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'ellipsis-horizontal-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ellipsis-horizontal-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'ellipsis-horizontal-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ellipsis-vertical-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'ellipsis-vertical-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ellipsis-vertical-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'ellipsis-vertical-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="enter-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'enter-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="exit-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'exit-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="expand-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'expand-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="extension-puzzle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'extension-puzzle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="eye-off-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'eye-off-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="eye-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'eye-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="eyedrop-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'eyedrop-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="fast-food-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'fast-food-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="female-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'female-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="file-tray-full-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'file-tray-full-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="file-tray-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'file-tray-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="file-tray-stacked-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'file-tray-stacked-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="film-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'film-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="filter-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'filter-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="filter-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'filter-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="finger-print-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'finger-print-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="fish-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'fish-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="fitness-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'fitness-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="flag-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'flag-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="flame-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'flame-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="flash-off-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'flash-off-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="flash-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'flash-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="flashlight-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'flashlight-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="flask-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'flask-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="flower-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'flower-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="folder-open-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'folder-open-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="folder-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'folder-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="football-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'football-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="footsteps-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'footsteps-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="funnel-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'funnel-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="game-controller-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'game-controller-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="gift-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'gift-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="git-branch-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'git-branch-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="git-commit-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'git-commit-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="git-compare-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'git-compare-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="git-merge-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'git-merge-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="git-network-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'git-network-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="git-pull-request-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'git-pull-request-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="glasses-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'glasses-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="globe-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'globe-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="golf-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'golf-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="grid-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'grid-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="hammer-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'hammer-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="hand-left-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'hand-left-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="hand-right-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'hand-right-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="happy-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'happy-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="hardware-chip-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'hardware-chip-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="headset-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'headset-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="heart-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'heart-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="heart-dislike-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'heart-dislike-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="heart-dislike-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'heart-dislike-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="heart-half-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'heart-half-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="heart-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'heart-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="help-buoy-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'help-buoy-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="help-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'help-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="help-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'help-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="home-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'home-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="hourglass-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'hourglass-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ice-cream-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'ice-cream-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="id-card-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'id-card-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="image-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'image-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="images-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'images-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="infinite-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'infinite-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="information-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'information-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="information-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'information-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="invert-mode-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'invert-mode-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="journal-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'journal-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="key-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'key-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="keypad-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'keypad-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="language-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'language-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="laptop-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'laptop-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="layers-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'layers-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="leaf-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'leaf-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="library-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'library-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="link-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'link-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="list-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'list-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="list-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'list-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="locate-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'locate-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="location-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'location-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="lock-closed-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'lock-closed-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="lock-open-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'lock-open-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="log-in-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'log-in-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="log-out-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'log-out-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="magnet-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'magnet-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="mail-open-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'mail-open-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="mail-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'mail-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="mail-unread-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'mail-unread-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="male-female-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'male-female-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="male-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'male-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="man-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'man-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="map-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'map-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="medal-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'medal-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="medical-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'medical-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="medkit-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'medkit-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="megaphone-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'megaphone-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="menu-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'menu-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="mic-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'mic-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="mic-off-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'mic-off-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="mic-off-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'mic-off-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="mic-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'mic-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="moon-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'moon-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="move-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'move-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="musical-note-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'musical-note-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="musical-notes-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'musical-notes-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="navigate-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'navigate-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="navigate-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'navigate-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="newspaper-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'newspaper-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="notifications-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'notifications-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="notifications-off-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'notifications-off-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="notifications-off-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'notifications-off-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="notifications-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'notifications-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="nuclear-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'nuclear-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="nutrition-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'nutrition-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="open-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'open-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="options-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'options-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="paper-plane-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'paper-plane-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="partly-sunny-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'partly-sunny-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pause-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'pause-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pause-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pause-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="paw-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'paw-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pencil-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pencil-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="people-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'people-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="people-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'people-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="person-add-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'person-add-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="person-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'person-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="person-remove-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'person-remove-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="person-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'person-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="phone-landscape-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'phone-landscape-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="phone-portrait-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'phone-portrait-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pie-chart-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pie-chart-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pin-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pin-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pint-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pint-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pizza-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pizza-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="planet-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'planet-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-back-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'play-back-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-back-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'play-back-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'play-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-forward-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'play-forward-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-forward-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'play-forward-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'play-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-skip-back-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'play-skip-back-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-skip-back-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'play-skip-back-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-skip-forward-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'play-skip-forward-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="play-skip-forward-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'play-skip-forward-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="podium-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'podium-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="power-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'power-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pricetag-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pricetag-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pricetags-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pricetags-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="print-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'print-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="prism-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'prism-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="pulse-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'pulse-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="push-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'push-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="qr-code-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'qr-code-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="radio-button-off-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'radio-button-off-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="radio-button-on-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'radio-button-on-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="radio-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'radio-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="rainy-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'rainy-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="reader-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'reader-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="receipt-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'receipt-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="recording-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'recording-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="refresh-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'refresh-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="refresh-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'refresh-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="reload-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'reload-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="reload-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'reload-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="remove-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'remove-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="remove-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'remove-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="reorder-four-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'reorder-four-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="reorder-three-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'reorder-three-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="reorder-two-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'reorder-two-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="repeat-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'repeat-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="resize-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'resize-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="restaurant-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'restaurant-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="return-down-back-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'return-down-back-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="return-down-forward-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'return-down-forward-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="return-up-back-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'return-up-back-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="return-up-forward-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'return-up-forward-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ribbon-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'ribbon-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="rocket-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'rocket-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="rose-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'rose-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="sad-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'sad-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="save-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'save-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="scale-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'scale-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="scan-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'scan-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="scan-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'scan-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="school-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'school-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="search-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'search-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="search-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'search-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="send-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'send-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="server-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'server-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="settings-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'settings-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="shapes-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'shapes-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="share-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'share-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="share-social-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'share-social-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="shield-checkmark-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'shield-checkmark-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="shield-half-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'shield-half-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="shield-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'shield-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="shirt-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'shirt-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="shuffle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'shuffle-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="skull-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'skull-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="snow-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'snow-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="sparkles-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'sparkles-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="speedometer-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'speedometer-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="square-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'square-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="star-half-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'star-half-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="star-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'star-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="stats-chart-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'stats-chart-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="stop-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'stop-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="stop-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'stop-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="stopwatch-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'stopwatch-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="storefront-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'storefront-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="subway-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'subway-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="sunny-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'sunny-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="swap-horizontal-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'swap-horizontal-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="swap-vertical-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'swap-vertical-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="sync-circle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'sync-circle-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="sync-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'sync-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="tablet-landscape-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'tablet-landscape-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="tablet-portrait-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'tablet-portrait-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="telescope-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'telescope-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="tennisball-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'tennisball-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="terminal-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'terminal-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="text-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'text-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="thermometer-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'thermometer-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="thumbs-down-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'thumbs-down-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="thumbs-up-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'thumbs-up-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="thunderstorm-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'thunderstorm-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="ticket-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'ticket-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="time-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'time-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="timer-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'timer-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="today-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'today-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="toggle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'toggle-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="trail-sign-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'trail-sign-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="train-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'train-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="transgender-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'transgender-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="trash-bin-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'trash-bin-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="trash-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'trash-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="trending-down-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'trending-down-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="trending-up-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'trending-up-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="triangle-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'triangle-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="trophy-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'trophy-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="tv-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'tv-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="umbrella-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'umbrella-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="unlink-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'unlink-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="videocam-off-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'videocam-off-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="videocam-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'videocam-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="volume-high-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'volume-high-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="volume-low-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'volume-low-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="volume-medium-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'volume-medium-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="volume-mute-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'volume-mute-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="volume-off-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'volume-off-sharp'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="walk-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'walk-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="wallet-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'wallet-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="warning-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'warning-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="watch-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'watch-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="water-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'water-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="wifi-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'wifi-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="wine-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'wine-sharp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="woman-sharp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'woman-sharp'}</div>
															</div>
														</div>
													</div>
													<div className="tab-pane fade" id="logo">
														<div className="row">
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-alipay"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-alipay'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-amazon"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-amazon'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-amplify"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-amplify'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-android"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-android'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-angular"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-angular'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-apple-appstore"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'logo-apple-appstore'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-apple-ar"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-apple-ar'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-apple"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-apple'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-behance"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-behance'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-bitbucket"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-bitbucket'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-bitcoin"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-bitcoin'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-buffer"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-buffer'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-capacitor"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-capacitor'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-chrome"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-chrome'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-closed-captioning"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'logo-closed-captioning'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-codepen"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-codepen'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-css3"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-css3'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-designernews"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'logo-designernews'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-deviantart"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-deviantart'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-discord"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-discord'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-docker"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-docker'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-dribbble"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-dribbble'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-dropbox"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-dropbox'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-edge"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-edge'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-electron"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-electron'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-euro"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-euro'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-facebook"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-facebook'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-figma"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-figma'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-firebase"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-firebase'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-firefox"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-firefox'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-flickr"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-flickr'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-foursquare"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-foursquare'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-github"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-github'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-gitlab"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-gitlab'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-google-playstore"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'logo-google-playstore'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-google"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-google'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-hackernews"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-hackernews'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-html5"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-html5'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-instagram"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-instagram'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-ionic"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-ionic'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-ionitron"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-ionitron'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-javascript"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-javascript'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-laravel"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-laravel'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-linkedin"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-linkedin'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-markdown"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-markdown'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-mastodon"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-mastodon'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-medium"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-medium'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-microsoft"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-microsoft'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-no-smoking"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-no-smoking'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-nodejs"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-nodejs'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-npm"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-npm'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-octocat"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-octocat'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-paypal"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-paypal'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-pinterest"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-pinterest'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-playstation"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'logo-playstation'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-pwa"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-pwa'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-python"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-python'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-react"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-react'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-reddit"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-reddit'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-rss"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-rss'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-sass"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-sass'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-skype"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-skype'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-slack"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-slack'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-snapchat"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-snapchat'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-soundcloud"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-soundcloud'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-stackoverflow"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'logo-stackoverflow'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-steam"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-steam'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-stencil"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-stencil'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-tableau"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-tableau'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-tiktok"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-tiktok'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-tumblr"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-tumblr'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-tux"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-tux'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-twitch"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-twitch'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-twitter"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-twitter'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-usd"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-usd'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-venmo"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-venmo'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-vercel"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-vercel'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-vimeo"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-vimeo'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-vk"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-vk'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-vue"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-vue'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-web-component"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">
																	{'logo-web-component'}
																</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-wechat"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-wechat'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-whatsapp"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-whatsapp'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-windows"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-windows'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-wordpress"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-wordpress'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-xbox"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-xbox'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-xing"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-xing'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-yahoo"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-yahoo'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-yen"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-yen'}</div>
															</div>
															<div className="col-md-6 col-12 py-2 d-flex align-items-center">
																<ion-icon
																	name="logo-youtube"
																	className="fa-2x fa-fw float-start me-2"
																></ion-icon>
																<div className="text-ellipsis">{'logo-youtube'}</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-icon-ionicons/code-1.json"
												/>
											</pre>
										</div>
									</div>
								</div>
							</div>
							<div className="col-xl-3">
								<nav
									data-init="scrollspy"
									className="navbar navbar-sticky navbar-sticky-start d-none d-xl-block py-4 h-100"
								>
									<nav className="nav">
										<a className="nav-link active" href="#usage" data-toggle="scroll-to">
											{'Usage'}
										</a>
									</nav>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default UIIconIonicons;
